















































































































































































































































































































































































































































































































































































































































import Vue, { PropType } from 'vue';
import { ProfileInfo } from 'spa_registration_app/store/modules/register';
import { serializeDateJp } from 'src/utils/date';
import { i18n, i18nHints } from 'src/plugins/i18n';
import { CvSectionProfileSexEnum } from 'gen';

export default Vue.extend({
  props: {
    isEditable: {
      type: Boolean,
      default: false,
    },
    profileInfo: {
      type: Object as PropType<ProfileInfo>,
      required: true,
    },
  },
  data() {
    return {
      formData: {
        full_name: this.profileInfo.full_name,
        birthday: this.profileInfo.birthday,
        sex: this.profileInfo.sex,
        email: this.profileInfo.email,
        phone_number: this.profileInfo.phone_number,
        location: this.profileInfo.location,
        headline: this.profileInfo.headline,
        website_url: this.profileInfo.website_url,
        profile_image: this.profileInfo.profile_image,
      },
    };
  },
  computed: {
    profileImage() {
      return this.profileInfo.profile_image
        ? URL.createObjectURL(this.profileInfo.profile_image)
        : '//proff-local.s3-ap-northeast-1.amazonaws.com/images/default-profile-icon.png';
    },
    today() {
      return new Date();
    },
    birthdayDisplay() {
      const [year, month, day] = this.formData.birthday
        ? this.formData.birthday.split('-')
        : [null, null, null];
      return serializeDateJp({ year, month, day });
    },
    sexDisplay() {
      if (!this.formData.sex) return '';
      return i18n.tc(
        i18nHints.models.cv_section_profile.sexes[this.formData.sex]
      );
    },
    sexOptions: (): Option[] => {
      const makeOption = sex => {
        return {
          value: sex,
          text: i18n.tc(i18nHints.models.cv_section_profile.sexes[sex]),
        };
      };
      return [
        makeOption(CvSectionProfileSexEnum.NotKnown),
        makeOption(CvSectionProfileSexEnum.Male),
        makeOption(CvSectionProfileSexEnum.Female),
        makeOption(CvSectionProfileSexEnum.NotApplicable),
      ];
    },
  },
  methods: {
    generateSubmitValue(): ProfileInfo {
      return {
        ...this.formData,
      };
    },
  },
});
